import {memo} from 'react'
import dateformat from 'src/utils/dateformat'

interface RowDataProps {
  items: any
  rowNumber: number
}

// eslint-disable-next-line react/display-name
export const RowData = memo(({items, rowNumber}: RowDataProps) => {
  return (
    <>
      {items?.map((audits: any, _index: number) => (
        <tr key={audits?.id ?? _index}>
          <td>{_index + 1 + rowNumber}</td>
          <td>{audits?.users?.name}</td>
          <td>
            {audits?.description} - {audits?.event}
          </td>
          <td>{dateformat(audits?.date as string)}</td>
          <td>{audits?.time}</td>
        </tr>
      ))}
    </>
  )
})
